import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { BUILDER } from 'shared/abilities';
import stylesGlobal from '../../../theme/facility-globals.scss';
import { section } from '../decorators';

const AboutWithPics = ({ children }) => {
  const [pic, header, content] = React.Children.toArray(children);

  return (
    <div className={stylesGlobal.section}>
      <Container>
        <Row className={stylesGlobal.verticalCenter}>
          {/* The 4-picture grid */}
          <Col md={6} xs={12} className={stylesGlobal.columnLeft}>
            {pic}
          </Col>
          {/* The narratives */}
          <Col md={6} xs={12} className={stylesGlobal.columnRight}>
            <div className={`${stylesGlobal.sectionHeader} color-primary-foreground`}>{header}</div>
            <div className={stylesGlobal.textContent}>{content}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

AboutWithPics.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = section(
  { name: 'Text With Image Grid', category: 'Images' },
  {
    subsections: [
      {
        accepts: [
          'Button',
          'ContentBox',
          'Coupon',
          'FacilityInformation',
          'MapboxMapAllFacilities',
          'MapboxMapOneFacility',
          'HeaderText',
          'Hours',
          'Image',
          'ImageGrid',
          'SocialMediaIcons',
        ],
      },
      {
        accepts: [
          'Button',
          'HeaderText',
          'SocialMediaIcons',
        ],
      },
      {
        accepts: [
          'Button',
          'ContentBox',
          'Coupon',
          'FacilityInformation',
          'FacilityAmenities',
          'MapboxMapAllFacilities',
          'MapboxMapOneFacility',
          'Hours',
          'Image',
          'SocialMediaIcons',
        ],
      },
    ],
    defaults: [
      ['ImageGrid'],
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'About Us',
              type: 'header-two',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
      ['ContentBox'],
    ],
  },
)(AboutWithPics);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
